import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { PagedResponse } from "@models/response.model";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import * as _ from "lodash";
import { ScrollListItemModel } from "@components/scroll-list/models/scroll-list-item.model";


/** TODO #CHALLENGE3 The ScrollList component should be a list that offers paged loading of items using an infinite scroll strategy.
 * Check if it works properly!
 **/
@Component({
    selector: 'app-scroll-list',
    templateUrl: './scroll-list.component.html',
    styleUrls: ['./scroll-list.component.scss']
})
export class ScrollListComponent implements OnInit {
    @Input() inputPlaceholder: string;
    @Input() inputLabel: string;
    @Input() isLoading: boolean;
    @Input() title: string;
    @Input() canAdd = true;

    @Input() items: PagedResponse<ScrollListItemModel>;
    @Input() isCreateSelected = false;

    /** TODO #CHALLENGE2 TableConfig is a handy class for pagination, filtering, sorting and searching.
     This is why it should be refactored into a standalone PagingConfig class and should be used as a default for paged lists.
     **/
    @Input() config: TableConfig;


    @Output() select = new EventEmitter<any>();
    @Output() reachEnd = new EventEmitter<any>();
    @Output() search = new EventEmitter<any>();
    @Output() create = new EventEmitter<any>();
    @Output() rightIconClick = new EventEmitter<any>();

    form: UntypedFormGroup;

    searchQuery = '';

    onSearchChange = _.debounce(this.onSearch, 300);

    constructor(public formBuilder: UntypedFormBuilder) {
        this.form = this.formBuilder.group({
            'search': [null],
        });
    }

    ngOnInit() {
    }

    hasItems() {
        return this.items && this.items.items && this.items.items.length > 0;
    }

    onSelect(item: ScrollListItemModel) {
        this.resetSelection();
        if (item) {
            item.selected = true;
        }
        this.select.emit(item);
    }

    onRightIconClick(item: ScrollListItemModel) {
        this.rightIconClick.emit(item);
    }

    onEnd(event) {
        if (!this.canAdd && (!this.items?.items || this.items.items.length === 0)) {
            return;
        }
        if (event.endIndex !== this.items.items.length - 1) {
            return;
        }
        if (this.items.items.length >= this.items.total) {
            return;
        }
        this.reachEnd.emit(this.config);
    }

    onSearch(value) {
        this.resetList();
        this.search.emit(value);
    }

    private resetSelection() {
        this.items.items.forEach(itm => itm.selected = false);
    }

    private resetList() {
        this.items = new PagedResponse<ScrollListItemModel>();
    }

    onCreate() {
        this.create.emit();
    }

    protected readonly toolbar = toolbar;
}
